"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../constants/index.js");
var _index2 = require("../../../helpers/index.js");
var currencyCodes = _index.eventFieldValues.currencyCodes;
var stringField = _index2.formatters.stringField,
  stringArrayField = _index2.formatters.stringArrayField,
  numberField = _index2.formatters.numberField;
var getPurchaseTemplate = function getPurchaseTemplate(_ref) {
  var priceTotal = _ref.priceTotal,
    deviceConfiguration = _ref.deviceConfiguration,
    productStatus = _ref.productStatus,
    numberOfRgus = _ref.numberOfRgus,
    numberOfAccessories = _ref.numberOfAccessories,
    numberOfPhones = _ref.numberOfPhones,
    numberOfTablets = _ref.numberOfTablets,
    numberOfWatches = _ref.numberOfWatches,
    purchaseID = _ref.purchaseID,
    deviceTradeIn = _ref.deviceTradeIn,
    conversionDate = _ref.conversionDate,
    cartID = _ref.cartID,
    cartSource = _ref.cartSource,
    checkoutType = _ref.checkoutType,
    checkoutSteps = _ref.checkoutSteps,
    _ref$shipBOPIS = _ref.shipBOPIS,
    shipBOPIS = _ref$shipBOPIS === void 0 ? false : _ref$shipBOPIS,
    _ref$shipToHome = _ref.shipToHome,
    shipToHome = _ref$shipToHome === void 0 ? true : _ref$shipToHome,
    shippingMethod = _ref.shippingMethod,
    transactionType = _ref.transactionType,
    payments = _ref.payments;
  var priceTotalValue = numberField(priceTotal);
  var paymentsValue = payments === null || payments === void 0 ? void 0 : payments.map(function (_ref2) {
    var activationFee = _ref2.activationFee,
      transactionID = _ref2.transactionID,
      paymentAmount = _ref2.paymentAmount,
      paymentType = _ref2.paymentType;
    return {
      _telus: {
        activationFee: {
          amount: numberField(activationFee)
        },
        customTransactionID: transactionID
      },
      paymentAmount: numberField(paymentAmount),
      paymentType: stringField(paymentType),
      currencyCode: currencyCodes.CAD,
      transactionID: transactionID
    };
  });
  return {
    _telus: {
      priceTotal: {
        amount: priceTotalValue
      },
      deviceConfiguration: stringField(deviceConfiguration),
      productStatus: productStatus,
      numberOfRgus: numberField(numberOfRgus),
      numberOfAccessories: numberField(numberOfAccessories),
      numberOfPhones: numberField(numberOfPhones),
      numberOfTablets: numberField(numberOfTablets),
      numberOfWatches: numberField(numberOfWatches)
    },
    purchases: {
      value: 1
    },
    cart: {
      cartID: cartID,
      cartSource: stringField(cartSource)
    },
    checkouts: {
      _telus: {
        checkoutSteps: stringArrayField(checkoutSteps, {
          separator: '|'
        }) || stringField(checkoutSteps)
      }
    },
    order: {
      purchaseID: purchaseID,
      currencyCode: currencyCodes.CAD,
      priceTotal: priceTotalValue,
      _telus: {
        priceTotal: priceTotalValue,
        deviceTradeIn: {
          amount: numberField(deviceTradeIn),
          conversionDate: stringField(conversionDate)
        },
        checkoutType: stringField(checkoutType),
        customPurchaseID: purchaseID,
        shipBOPIS: shipBOPIS,
        shipToHome: shipToHome,
        shippingMethod: stringField(shippingMethod),
        transactionType: stringField(transactionType)
      },
      payments: paymentsValue
    }
  };
};
var _default = exports["default"] = getPurchaseTemplate;